/**
 * @generated SignedSource<<1dfeb904181604d0c5509b9c65dd48fb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type RoutineOccasionStatus = "COMPLETED" | "FUTURE" | "IN_PROGRESS" | "IN_PROGRESS_EXPIRED" | "NOT_COMPLETED" | "NOT_COMPLETED_STARTED" | "NO_TASKS_COMPLETED" | "REQUIRED_COMPLETED";
import { FragmentRefs } from "relay-runtime";
export type WorkspaceRoutineOccasionStoresList_routineWorkspaceOccasion$data = {
  readonly occasions: ReadonlyArray<{
    readonly occasion: {
      readonly id: string;
      readonly issueCount: number;
      readonly occasionStatus: RoutineOccasionStatus;
      readonly registeredIssueCount: number;
      readonly routine: {
        readonly id: string;
      };
    };
    readonly store: {
      readonly id: string;
      readonly name: string;
    };
    readonly " $fragmentSpreads": FragmentRefs<"WorkspaceRoutineOccasionStoresListItem_routineWorkspaceOccasion">;
  }>;
  readonly routine: {
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"WorkspaceRoutineOccasionDescription_routine">;
  };
  readonly totalTaskExecutionCount: number | null;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceRoutineOccasionListHeader_RoutineWorkspaceOccasion">;
  readonly " $fragmentType": "WorkspaceRoutineOccasionStoresList_routineWorkspaceOccasion";
};
export type WorkspaceRoutineOccasionStoresList_routineWorkspaceOccasion$key = {
  readonly " $data"?: WorkspaceRoutineOccasionStoresList_routineWorkspaceOccasion$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceRoutineOccasionStoresList_routineWorkspaceOccasion">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WorkspaceRoutineOccasionStoresList_routineWorkspaceOccasion",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WorkspaceRoutineOccasionListHeader_RoutineWorkspaceOccasion"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Routine",
      "kind": "LinkedField",
      "name": "routine",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WorkspaceRoutineOccasionDescription_routine"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalTaskExecutionCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RoutineWorkspaceOccasionEdge",
      "kind": "LinkedField",
      "name": "occasions",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Store",
          "kind": "LinkedField",
          "name": "store",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "RoutineOccasion",
          "kind": "LinkedField",
          "name": "occasion",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Routine",
              "kind": "LinkedField",
              "name": "routine",
              "plural": false,
              "selections": [
                (v0/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": "occasionStatus",
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "issueCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "registeredIssueCount",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WorkspaceRoutineOccasionStoresListItem_routineWorkspaceOccasion"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "RoutineWorkspaceOccasion",
  "abstractKey": null
};
})();

(node as any).hash = "dd958398e95affdc2c4f196786008004";

export default node;
